<template>
    <div class="io-radios">
        <label v-html="label"></label>
        <div>
            <label
                v-for="(item, index) in items"
                class="io-radio"
                :class="{ 'checked' : item.value === modelValue }"
            >
                <span>
                    {{ item.label }}
                </span>
                <input
                    type="radio"
                    :checked="item.value === modelValue"
                    :value="item.value"
                    :name="name"
                    v-model="modelValue"
                    @input="updateInput"
                >
            </label>
        </div>
    </div>
</template>

<script>
export default {
  name: 'IoRadio',

  model: {
    prop: 'modelValue',
    event: 'input',
  },

  props: {
    value: {
      type: String,
    },
    modelValue: {
      default: '',
    },
    name: {
      required: true,
    },
    label: {
      required: true,
    },
    items: {
      required: true,
    },
  },

  methods: {
    updateInput(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>
